(() => {
  const INIT_ATTR = 'data-bcgift-product-referral-initialized';
  const CAPTURE_ONCE_KEY = '__bcgiftProductReferralCaptureOnce';

  function setStatus(node, message, isError = false) {
    if (!node) return;
    node.textContent = message || '';
    node.style.color = isError ? '#b42318' : '#666';
  }

  function buildCanonicalProductUrl(productPath, origin) {
    const url = new URL(productPath, origin);
    url.search = '';
    url.hash = '';
    return url;
  }

  function buildReferralProductUrl(productPath, referralCode, origin) {
    if (!productPath || !referralCode) return '';
    const url = buildCanonicalProductUrl(productPath, origin);
    url.searchParams.set('ref', String(referralCode).trim().toUpperCase());
    return url.toString();
  }

  function buildWhatsAppShareUrl(shareLink) {
    if (!shareLink) return '';
    const isZh = /^zh(?:-|$)/i.test(document.documentElement.lang || window.Shopify?.language || '');
    const message = isZh
      ? `在 BCgift 看到这件商品，分享给你：${shareLink}`
      : `Thought you might like this product from BCgift: ${shareLink}`;
    return 'https://wa.me/?text=' + encodeURIComponent(message);
  }

  async function captureReferralFromUrl({ currentPath }) {
    if (window[CAPTURE_ONCE_KEY]) return;

    const currentUrl = new URL(window.location.href);
    const ref = currentUrl.searchParams.get('ref') || currentUrl.searchParams.get('referral');
    if (!ref) return;

    window[CAPTURE_ONCE_KEY] = true;

    try {
      await fetch(
        '/apps/bcgift-member/api/referral-capture?ref=' + encodeURIComponent(ref) +
          '&sourceType=product_link' +
          '&sourceValue=' + encodeURIComponent(currentPath || window.location.pathname) +
          '&landingPath=' + encodeURIComponent(currentPath || window.location.pathname),
        {
          method: 'GET',
          credentials: 'include',
          headers: { Accept: 'application/json' },
        }
      );
    } catch (error) {
      console.warn('BCgift referral capture failed', error);
    }
  }

  async function fetchMemberReferralCode(customerId) {
    if (!customerId) return null;

    try {
      const response = await fetch(
        '/apps/bcgift-member/api/member-summary?customer_gid=' + encodeURIComponent(`gid://shopify/Customer/${customerId}`),
        {
          method: 'GET',
          credentials: 'include',
          headers: { Accept: 'application/json' },
        }
      );
      const json = await response.json().catch(() => null);
      if (!response.ok || !json || json.ok === false) return null;

      const code = json.summary && json.summary.referralCode;
      if (!code || code === '-') return null;
      return String(code).trim().toUpperCase();
    } catch (error) {
      console.warn('BCgift member summary fetch failed', error);
      return null;
    }
  }

  async function initReferralWidget(wrapper) {
    if (!wrapper || wrapper.hasAttribute(INIT_ATTR)) return;
    wrapper.setAttribute(INIT_ATTR, 'true');

    const copyButton = wrapper.querySelector('[data-bcgift-copy-product-referral]');
    const whatsappButton = wrapper.querySelector('[data-bcgift-whatsapp-product-referral]');
    const statusNode = wrapper.querySelector('[data-bcgift-copy-product-referral-status]');
    const productPath = wrapper.getAttribute('data-product-path') || window.location.pathname;
    const customerId = wrapper.getAttribute('data-customer-id');
    const origin = window.location.origin;

    await captureReferralFromUrl({ currentPath: productPath });

    const referralCode = await fetchMemberReferralCode(customerId);
    if (!referralCode || !copyButton) return;

    const referralLink = buildReferralProductUrl(productPath, referralCode, origin);
    if (!referralLink) return;

    const whatsappShareUrl = buildWhatsAppShareUrl(referralLink);

    copyButton.hidden = false;
    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(referralLink);
        const isZh = /^zh(?:-|$)/i.test(document.documentElement.lang || window.Shopify?.language || '');
        setStatus(statusNode, isZh ? '已复制' : 'Copied');
      } catch (error) {
        console.warn('BCgift referral product link copy failed', error);
        const isZh = /^zh(?:-|$)/i.test(document.documentElement.lang || window.Shopify?.language || '');
        setStatus(statusNode, isZh ? '无法复制链接' : 'Unable to copy link', true);
      }
    });

    if (whatsappButton && whatsappShareUrl) {
      whatsappButton.hidden = false;
      whatsappButton.href = whatsappShareUrl;
      whatsappButton.target = '_blank';
      whatsappButton.rel = 'noopener noreferrer';
    }
  }

  function initAllReferralWidgets() {
    document.querySelectorAll('[data-bcgift-product-referral]').forEach((node) => {
      initReferralWidget(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllReferralWidgets, { once: true });
  } else {
    initAllReferralWidgets();
  }
})();
